module.exports = __webpack_public_path__ + "img/no-belyashi-sticker.b6b180f7.png";